'use client';

import useLogEvents from '@/lib/client-hook/use-log-events';
import { Languages } from '@/lib/dictionaries';
import CheckIcon from '@/public/images/ic_message_check.svg';
import ShareIcon from '@/public/images/ic_share.svg';
import Image from 'next/image';
import { usePathname } from 'next/navigation';
import React, { useEffect, useRef } from 'react';

import classes from './shop-detail-share.module.scss';

function ShopDetailShare({
  dict,
  shopTitle,
  language,
}: {
  dict: { shareNow: string; copyLink: string; close: string };
  shopTitle: string;
  language: Languages;
}) {
  const pathname = usePathname();
  const { logShareEvent } = useLogEvents();

  const intervalRef = useRef<NodeJS.Timeout | null>(null);

  const [openPopup, setOpenPopup] = React.useState(false);
  const [link, setLink] = React.useState(
    `${process.env.NEXT_PUBLIC_API_URL}/${decodeURI(pathname)}`,
  );
  const [isCopied, setCopied] = React.useState(false);

  const handleShare = async () => {
    logShareEvent('bnb_shop_detail_share', {
      title: shopTitle,
      language: language,
    });
    try {
      window.flutter_inappwebview.callHandler('handleCopyRequest', [
        {
          link,
        },
      ]);
    } catch (e) {
      setOpenPopup(prev => !prev);
    }
  };

  const copyToClipboard = () => {
    if (intervalRef.current) {
      clearInterval(intervalRef.current);
    }
    setCopied(true);
    navigator.clipboard.writeText(link);
    intervalRef.current = setInterval(() => {
      setCopied(false);
    }, 2000);
  };

  useEffect(() => {
    setLink(`${process.env.NEXT_PUBLIC_API_URL}/${decodeURI(pathname)}`);
  }, [pathname]);

  return (
    <>
      <button onClick={handleShare}>
        <Image src={ShareIcon} alt="Share" width={18} height={20} />
      </button>
      <div
        className={classes.shareBox}
        style={{ display: openPopup ? 'flex' : 'none' }}
      >
        <p>{dict.shareNow}</p>
        <div className={classes.linkBox}>
          <div className={classes.link}>{link}</div>
          <button onClick={copyToClipboard} disabled={isCopied}>
            {isCopied ? (
              <Image src={CheckIcon} alt="Copied" width={18} height={18} />
            ) : (
              dict.copyLink
            )}
          </button>
        </div>
        <div className={classes.closeBox}>
          <button className={classes.close} onClick={handleShare}>
            {dict.close}
          </button>
        </div>
      </div>
    </>
  );
}

export default ShopDetailShare;
